<div class="stepper" role="list">
  <ng-container *ngFor="let step of steps; let i = index">
    <div class="step" role="listitem" [attr.data-status]="getStatus(i)">
      <div class="step__icon" aria-hidden="true">
        <ng-container [ngSwitch]="step.icon">
          <svg *ngSwitchCase="'business'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
            <path d="M4 21V7a2 2 0 0 1 2-2h6l2 2h4a2 2 0 0 1 2 2v12"></path>
            <path d="M8 21v-8"></path>
            <path d="M12 21v-8"></path>
          </svg>
          <svg *ngSwitchCase="'directors'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
            <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
            <circle cx="9" cy="7" r="3"></circle>
            <path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
            <path d="M16 3.13a3 3 0 0 1 0 5.75"></path>
          </svg>
          <svg *ngSwitchCase="'bank'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
            <rect x="3" y="6" width="18" height="12" rx="2"></rect>
            <path d="M3 10h18"></path>
          </svg>
          <svg *ngSwitchCase="'documents'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
            <path d="M14 2v6h6"></path>
            <path d="M8 13h8"></path>
            <path d="M8 17h6"></path>
          </svg>
        </ng-container>
      </div>
      <div class="step__label">{{ step.label }}</div>
    </div>

    <div
      *ngIf="i < steps.length - 1"
      class="connector"
      [attr.data-status]="i < activeIndex ? 'done' : 'upcoming'"
      aria-hidden="true"
    ></div>
  </ng-container>
</div>

